// @ts-check

import datepicker from "js-datepicker";

datepicker(".date-input", {
  formatter: (input, date, instance) => {
    const value =
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    input.value = value;
  },
});
